/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DrawerOpenLeftIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="drawer-open-left"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 6.5C2.5 5.395 3.395 4.5 4.5 4.5L19.5 4.5C20.605 4.5 21.5 5.395 21.5 6.5L21.5 17.5C21.5 18.605 20.605 19.5 19.5 19.5L4.5 19.5C3.395 19.5 2.5 18.605 2.5 17.5L2.5 6.5Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 10C6.008 9.774 6.036 9.557 6.11 9.343C6.167 9.18 6.245 9.025 6.342 8.882C6.437 8.74 6.551 8.611 6.679 8.498C7.043 8.178 7.516 8.001 8 8C8.667 7.999 9.333 7.999 10 8C10.267 8.001 10.532 8.053 10.778 8.157C10.884 8.202 10.909 8.218 11.009 8.273C11.155 8.365 11.292 8.463 11.414 8.586C11.788 8.959 11.999 9.472 12 10C12.001 11.333 12 12.667 12 14C11.992 14.226 11.964 14.443 11.89 14.657C11.833 14.82 11.755 14.975 11.658 15.118C11.563 15.26 11.449 15.389 11.321 15.502C10.957 15.822 10.484 15.999 10 16C9.333 16.001 8.667 16.001 8 16C7.733 15.999 7.468 15.947 7.222 15.843C7.116 15.798 7.091 15.782 6.991 15.727C6.845 15.635 6.708 15.537 6.586 15.414C6.212 15.041 6.001 14.528 6 14C5.999 12.667 6 11.333 6 10Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M6 10C6 8.895 6.895 8 8 8L10 8C11.105 8 12 8.895 12 10L12 14C12 15.105 11.105 16 10 16L8 16C6.895 16 6 15.105 6 14L6 10Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
